import * as url from "../url_helper";

import { get, post } from "../api_helper";

export const getSalesOfficeOptionList = data => get(url.GET_SALES_OFFICE_OPTIONS, data);
export const addSalesOffice = data => post(url.ADD_NEW_SALES_OFFICE, data);
export const getSalesOffice = data => post(url.GET_SALES_OFFICE, data);
export const getSalesOfficeList = data => post(url.GET_SALES_OFFICE_LIST, data);
export const getSalesOfficeFilter = data => get(url.GET_SALES_OFFICE_FILTER, data);
export const editSalesOffice = data => post(url.UPDATE_SALES_OFFICE, data);
export const deleteSalesOffice = data => post(url.DELETE_SALES_OFFICE, data);
export const getSalesOfficeListForSelect = data => post(url.GET_SALES_OFFICE_LIST_FOR_SELECT, data);
export const getReportToListForSelect = data => post(url.GET_REPORTS_TO_LIST_FOR_SELECT, data);
export const updateDealerSalesOfficeMapping = data => post(url.ADD_DEALER_SALES_OFFICE_MAPPING, data);


